module.exports = __webpack_public_path__ + "img/off.21a51b48.png";